import { motion } from "framer-motion";

const chapters = [
  { n: "01", t: "Simplicidade", d: "Interfaces intuitivas que eliminam a curva de aprendizado. Qualquer colaborador opera no primeiro dia." },
  { n: "02", t: "Potência", d: "Arquitetura robusta e desktop-first, pensada para suportar o crescimento e o volume do seu negócio." },
  { n: "03", t: "Escala", d: "Soluções que evoluem com a sua demanda. Módulos personalizados quando você precisar de mais." },
];

const reveal = {
  hidden: { opacity: 0, y: 40 },
  show: (i) => ({ opacity: 1, y: 0, transition: { duration: 0.7, ease: [0.22, 1, 0.36, 1], delay: i * 0.1 } }),
};

export const Manifesto = () => (
  <section id="manifesto" className="py-24 md:py-40">
    <div className="max-w-7xl mx-auto px-6 md:px-12">
      <div className="flex items-center gap-3 mb-16">
        <span className="font-mono text-xs uppercase tracking-[0.3em] text-white/50">O Manifesto</span>
      </div>
      <div className="border-t border-white/10">
        {chapters.map((c, i) => (
          <motion.div
            key={c.n}
            custom={i} variants={reveal} initial="hidden" whileInView="show" viewport={{ once: true, margin: "-80px" }}
            className="group grid md:grid-cols-12 gap-6 md:gap-8 items-start py-10 md:py-14 border-b border-white/10 hover:bg-surface/40 transition-colors duration-500 px-2 md:px-4"
            data-testid={`manifesto-${c.n}`}>
            <div className="md:col-span-2 font-mono text-cobalt text-sm">/{c.n}</div>
            <h3 className="md:col-span-4 font-head font-bold text-3xl md:text-5xl tracking-tight leading-[1.05] group-hover:translate-x-2 transition-transform duration-500">{c.t}</h3>
            <p className="md:col-span-6 text-white/55 text-lg leading-relaxed">{c.d}</p>
          </motion.div>
        ))}
      </div>
    </div>
  </section>
);
